/* === КОНФИГУРАЦИЯ УРОВНЕЙ === */
const LEVELS_CONFIG = [
  {
    id: 'lvl1',
    threshold: 10000, // €100.00 в центах
    startDate: '2026-07-10T00:00:00', // дата начала
    endDate: '2026-07-19T23:59:59',// дата окончания
    activeText: 'Nog {left} excl. btw te gaan voor een JULY SPECIAL GOODIEBAG. Geldig vanaf €100,- excl. btw NA korting. Alleen geldig van 17 t/m 19 Juli.', 
    // {% comment %} activeText: 'Nog {left} excl. btw te gaan voor een GRATIS MINI goodiebag (t.w.v. €25,-). Geldig vanaf €150,- excl. btw NA korting.',  {% endcomment %}
    doneText: '🎁 Bij een ordertotaal van €100,- excl. btw NA korting ontvang je automatisch een GRATIS JULY SPECIAL GOODIEBAG. Alleen geldig van 17 t/m 19 Juli. Kortingen die nog worden toegepast kunnen invloed hebben op deze actie.', 
    // {% comment %} doneText: '🎁 Bij een ordertotaal van €150,- excl. btw NA korting ontvang je automatisch een GRATIS MINI goodiebag. Kortingen die nog worden toegepast kunnen invloed hebben op deze actie.',  {% endcomment %}
    color: '#4CAF50', // цвет прогресс-бара
    images: [ // МАССИВ картинок для слайдера
      'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_JULY_SPECIAL.png?v=1784278875',
      // 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_NO_BG.png?v=1768148982', 
      'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_ITEM_001.png?v=1768306095',
      'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_ITEM_002.png?v=1768306095',
      // 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_ITEM_003.png?v=1768306094' 
    ] 
  },
  {
    id: 'lvl2',
    threshold: 15000, // €150.00
    startDate: '2026-07-20T00:00:00',
    endDate: '2036-06-30T06:00:00',
    activeText: 'Nog {left} excl. btw te gaan voor een GRATIS MINI goodiebag (t.w.v. €25,-). Geldig vanaf €150,- excl. btw NA korting.', 
    doneText: '🎁 Bij een ordertotaal van €150,- excl. btw NA korting ontvang je automatisch een GRATIS MINI goodiebag. Kortingen die nog worden toegepast kunnen invloed hebben op deze actie.', 
    color: '#4CAF50',
    images: [
      'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_NO_BG.png?v=1768148982',
      // 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_VIP_NO_BG.png?v=1770641999',       
    ]    
  },
  
  /**/
  // Добавляйте новые уровни здесь по той же схеме
];

/* === НАСТРОЙКИ === */
const FS_SYMBOL = '€';

/* === ВСПОМОГАТЕЛЬНЫЕ ФУНКЦИИ === */

// Форматирование денег из центов
function fsFmt(cents) {
  return FS_SYMBOL + (cents / 100).toFixed(2);
}

// Получить корзину
async function fsGetCart() {
  const r = await fetch('/cart.js', { credentials: 'same-origin' });
  return r.json();
}

// Проверка, активен ли уровень по датам
function isLevelActive(level) {
  const now = new Date();
  const start = level.startDate ? new Date(level.startDate) : null;
  const end = level.endDate ? new Date(level.endDate) : null;

  if (start && now < start) return false;
  if (end && now >= end) return false;

  return true;
}

// Найти текущий активный уровень на основе суммы корзины
function getCurrentLevel(cartTotal) {
  // Фильтруем активные уровни по датам
  const activeLevels = LEVELS_CONFIG.filter(isLevelActive);
  
  if (activeLevels.length === 0) return null;

  // Сортируем по порогу (от меньшего к большему)
  activeLevels.sort((a, b) => a.threshold - b.threshold);
  
  // Ищем первый НЕдостигнутый уровень
  for (let level of activeLevels) {
    if (cartTotal < level.threshold) {
      return level; // Показываем этот уровень
    }
  }
  
  // Если все уровни достигнуты, показываем последний (самый высокий) с поздравлением
  return activeLevels[activeLevels.length - 1];
}

// Слайдер картинок с плавной сменой
let currentSliderInterval = null;

function startImageSlider(imgElement, images) {
  // Останавливаем предыдущий слайдер
  if (currentSliderInterval) {
    clearInterval(currentSliderInterval);
  }

  if (!images || images.length === 0) return;

  let currentIndex = 0;
  
  // Устанавливаем первую картинку
  imgElement.src = images[0];
  imgElement.style.transition = 'opacity 0.5s ease-in-out';
  imgElement.style.opacity = '1';

  // Если только одна картинка - не запускаем слайдер
  if (images.length === 1) return;

  // Запускаем интервал смены картинок
  currentSliderInterval = setInterval(() => {
    imgElement.style.opacity = '0';
    
    setTimeout(() => {
      currentIndex = (currentIndex + 1) % images.length;
      imgElement.src = images[currentIndex];
      imgElement.style.opacity = '1';
    }, 500);
    
  }, 2000); // Меняем каждые 2 секунды
}

/* === СОЗДАНИЕ HTML ДЛЯ УРОВНЯ === */

function createLevelHTML(level) {
  return `
    <div class="fs-wrapper">
      <div class="fs-image-bg">
        <img src="" alt="Gift product" class="fs-product-img">
      </div>
      <div class="fs-content">
        <div class="fs-track">
          <div class="fs-fill"></div>
        </div>
        <p class="fs-msg"></p>
      </div>
    </div>
  `;
}

/* === ОСНОВНАЯ ЛОГИКА === */

async function fsRender() {
  try {
    // Получаем данные корзины
    const cart = await fsGetCart();
    const total = cart?.total_price || 0;

    // Получаем текущий активный уровень
    const currentLevel = getCurrentLevel(total);

    // Находим контейнер
    const container = document.getElementById('progress-levels-container');
    if (!container) return;

    // Если нет активных уровней - прячем контейнер
    if (!currentLevel) {
      container.style.display = 'none';
      return;
    }

    // Показываем контейнер
    container.style.display = '';

    // Создаём HTML если его ещё нет
    if (!container.innerHTML.trim()) {
      container.innerHTML = createLevelHTML(currentLevel);
    }

    // Находим элементы внутри блока
    const fill = container.querySelector('.fs-fill');
    const msg = container.querySelector('.fs-msg');
    if (!fill || !msg) return;

    // Сколько осталось до порога
    const left = Math.max(0, currentLevel.threshold - total);
    
    // Процент заполнения (не больше 100)
    const pct = Math.min(100, Math.round((total / currentLevel.threshold) * 100));

    // Задаём ширину прогресс-бара
    fill.style.width = pct + '%';

    // Применяем цвет из конфига
    if (currentLevel.color) {
      fill.style.backgroundColor = currentLevel.color;
    }

    // Запускаем слайдер картинок
    const imgEl = container.querySelector('.fs-product-img');
    if (imgEl && currentLevel.images) {
      startImageSlider(imgEl, currentLevel.images);
    }

    // Выбираем состояние и текст
    if (left > 0) {
      container.classList.add('is-active');
      container.classList.remove('is-done');
      msg.textContent = currentLevel.activeText.replace('{left}', fsFmt(left));
    } else {
      container.classList.remove('is-active');
      container.classList.add('is-done');
      msg.textContent = currentLevel.doneText;
    }

  } catch (e) {
    console.warn('Progress bar render error:', e);
  }
}

/* === ИНИЦИАЛИЗАЦИЯ И ОБНОВЛЕНИЯ === */

// Первичная отрисовка при загрузке
document.addEventListener('DOMContentLoaded', fsRender);

// Перехватываем fetch к /cart/*
(function() {
  const _f = window.fetch;
  window.fetch = async function(i, init) {
    const res = await _f(i, init);
    try {
      const url = typeof i === 'string' ? i : (i?.url || '');
      if (url.includes('/cart/')) setTimeout(fsRender, 80);
    } catch (_) {}
    return res;
  };
})();

// Ловим XHR-запросы к /cart/* (jQuery/старые темы)
(function() {
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.__fsIsCart = typeof url === 'string' && url.includes('/cart/');
    return origOpen.apply(this, arguments);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    this.addEventListener('load', () => {
      if (this.__fsIsCart) setTimeout(fsRender, 80);
    });
    return origSend.apply(this, arguments);
  };
})();

// Следим за перерисовкой cart-секции
(function() {
  const target =
    document.querySelector('[data-section-type="cart-template"]') ||
    document.querySelector('form.cart-form') ||
    document.body;

  const mo = new MutationObserver(() => {
    clearTimeout(window.__fsDebounce);
    window.__fsDebounce = setTimeout(fsRender, 60);
  });
  mo.observe(target, { subtree: true, childList: true });
})();

// События корзины
window.addEventListener('cart:updated', fsRender);
document.addEventListener('ajaxCart:updated', fsRender);
document.addEventListener('cc:cart-updated', fsRender);